export default "__VITE_ASSET__DpWf_Nxn__"